import { render, staticRenderFns } from "./HRCTransactionCard.vue?vue&type=template&id=2cf1db30&scoped=true&"
import script from "./HRCTransactionCard.vue?vue&type=script&lang=js&"
export * from "./HRCTransactionCard.vue?vue&type=script&lang=js&"
import style0 from "./HRCTransactionCard.vue?vue&type=style&index=0&id=2cf1db30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1db30",
  null
  
)

export default component.exports